// extracted by mini-css-extract-plugin
export default {"modalContentContainerElementId":"ActivityFeedModal_modalContentContainerElementId__0NI1H"};